"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("../styles");
function LoadingPatientInfo() {
    return (react_1.default.createElement(styles_1.LoadingContainer, { "data-testid": "Loading" },
        react_1.default.createElement(styles_1.LoadingMain, null,
            react_1.default.createElement(styles_1.ContentHeader, null,
                react_1.default.createElement(styles_1.LoadingCell, null)),
            react_1.default.createElement(styles_1.ContentLabel, null,
                react_1.default.createElement(styles_1.LoadingCell, null)),
            react_1.default.createElement(styles_1.ContentInputRow, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.LoadingCell, null))),
            react_1.default.createElement(styles_1.ContentLabel, null,
                react_1.default.createElement(styles_1.LoadingCell, null)),
            react_1.default.createElement(styles_1.ContentInputRow, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.LoadingCell, null))),
            react_1.default.createElement(styles_1.ContentLabel, null,
                react_1.default.createElement(styles_1.LoadingCell, null)),
            react_1.default.createElement(styles_1.ContentInputRow, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.LoadingCell, null))),
            react_1.default.createElement(styles_1.ContentLabel, null,
                react_1.default.createElement(styles_1.LoadingCell, null)),
            react_1.default.createElement(styles_1.ContentInputRow, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.LoadingCell, null))),
            react_1.default.createElement(styles_1.ContentInputRow, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.LoadingCell, null))),
            react_1.default.createElement(styles_1.ContentInputRow, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.LoadingCell, null)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.LoadingCell, null)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.LoadingCell, null))))));
}
exports.default = LoadingPatientInfo;
//# sourceMappingURL=LoadingPatientInfo.js.map